let menu = document.querySelector('.menu-main');
if (menu) {
  let icon = document.querySelectorAll('.mobile-icon');
  icon.forEach((item) => {
    item.addEventListener('click', () => {
      item.parentNode.classList.toggle('open');
    });
  });
}
